export type GoogleComponentResources = {
    [K in
    'googleButtonLabel' |
    'googleScriptLoadingErrorMessage' |
    'signInPromptNotDisplayedMessage' |
    'singInPromptSkipped' |
    'errorInitializingSignInMessage' |
    'clientIdRequiredErrorMessage' |
    'decodingTokerErrorMessage'
    ]: string;
};

// Default values for the resources
export const DefaultGoogleComponentResource: GoogleComponentResources = {
    googleButtonLabel: "Continue with Google",
    googleScriptLoadingErrorMessage: 'Error loading Google script:',
    signInPromptNotDisplayedMessage: 'Google Sign-In prompt not displayed:',
    singInPromptSkipped: "Google Sign-In prompt was skipped:",
    errorInitializingSignInMessage: "Error initializing Google Sign-In:",
    clientIdRequiredErrorMessage: "ClientId is a required parameter.",
    decodingTokerErrorMessage: "Error decoding token:"
};
